import mixpanel from 'mixpanel-browser';
import { APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { RouterStateSerializer } from '@ngrx/router-store';

import { SegmentModule } from 'ngx-segment-analytics';

import { TokenInterceptor } from '@unico-people/utils-interceptor';
import { AppRoutingModule } from './app-routing.module';

import { JwtModule } from '@auth0/angular-jwt';
import { NgxPermissionsModule } from 'ngx-permissions';

import { AppComponent } from './app.component';

import { environment } from '../environments/environment';

import { reducers, effects, DataAccessStoreModule } from '@unico-people/shared/dashboard/data-access-store';
import { CustomSerializer } from '@unico-people/shared/dashboard/data-access-store';
import { GlobalErrorHandler } from '../../../../libs/ongoing/src/lib/services/error/error.service';
import { LaunchdarklyService } from '@acesso-io/launchdarkly-client-ts/lib/launchdarkly';
import { MatDialogModule } from '@angular/material/dialog';
import * as ld from 'launchdarkly-js-client-sdk';

import * as Sentry from '@sentry/angular-ivy';
import { Router } from '@angular/router';
import { getTokenStorage } from '@unico-people/shared/utils/storage';

const context = {
  anonymous: true,
  custom: {
    appName: 'collaborators'
  }
} as ld.LDContext;

export function tokenGetter() {
  return   getTokenStorage();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxPermissionsModule.forRoot(),
    StoreModule.forRoot(reducers, {
      metaReducers: !environment.production ? [] : [],
      runtimeChecks: {
        strictActionImmutability: true,
        strictStateImmutability: true
      }
    }),
    EffectsModule.forRoot(effects),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    SegmentModule.forRoot({ apiKey: '', debug: false, loadOnInitialization: false }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter
      }
    }),
    DataAccessStoreModule,
    MatDialogModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: RouterStateSerializer, useClass: CustomSerializer },
    { provide: LaunchdarklyService, useFactory: () => new LaunchdarklyService(environment.launchDarklyClientId)},
    {
        provide: APP_INITIALIZER,
        useFactory: (ld: LaunchdarklyService) => async() => {
        await ld.init({context})

        mixpanel.init(
          environment.mixpanel_token,
          { debug: !environment.production, track_pageview: true, persistence: 'localStorage' }
        )
      },
      multi: true,
      deps: [LaunchdarklyService]
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: Sentry.TraceService,
      deps: [Router]
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
